import { OrderRepository } from "../Repository/OrderRepository";

export interface AddingInvoiceUseCase {
  invoke: (data: any) => Promise<boolean>;
}

export class AddingInvoice implements AddingInvoiceUseCase {
  private repo: OrderRepository;
  constructor(_Repo: OrderRepository) {
    this.repo = _Repo;
  }

   invoke(data: any){
    if(!data){
        throw new Error(
            "No tiene la data necesaria."
          );
    }
    const getData = this.repo.addingInvoice(data);
    return getData;
  }
}